import { Expose, Type } from 'class-transformer'
import { MeetingRoom } from '@material-ui/icons'

import { Facility } from './Facility'

export enum DockType {
  ramp = "ramp",
  standard = "standard",
  rail = "rail",
}

export class Dock {
  static type = 'dock'

  icon = MeetingRoom

  type = Dock.type

  static DockType = DockType

  guid: string = ''

  @Type(() => Facility)
  facility: Facility = new Facility()

  name: string = ''

  @Expose({ name: 'dock_type' })
  dockType?: DockType

  get path() {
    const items = []
    if (this.facility) {
      items.push(this.facility.name)
    }
    items.push(this.name)
    return items.join(' > ')
  }
}
